import { CallExpressionShape, Plugin } from '@servicenow/sdk-build-core'
import { LANE_API_NAME } from '../constants/playbook-plugin-constants'

/**
 * Validates Lane calls and emits diagnostics for invalid things.
 *
 * Note: This plugin returns { success: false } to indicate it is for diagnostics only
 * and does not create records.
 */
export const LaneDiagnosticsPlugin = Plugin.create({
    name: 'LaneDiagnosticsPlugin',

    shapes: [
        {
            shape: CallExpressionShape,
            fileTypes: ['fluent'],

            toRecord(callExpression) {
                // Only handle Lane calls
                if (callExpression.getCallee() !== LANE_API_NAME) {
                    return { success: false }
                }

                // Don't create a record - this is diagnostics only
                return { success: false }
            },
        },
    ],
    docs: [],
})
